// @ts-nocheck
import React, { useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

import Navigation from 'components/Navigation';
import OmniSearch from 'components/OmniSearch';
import Footer from 'components/Footer';

import styled from '@emotion/styled';

import '../App.css';

const SIDEBAR_WIDTH = 240;

const AppDiv = styled.div({
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'row',
    overflow: 'hidden',
    '@media print': {
        width: 'auto',
        height: 'auto',
        display: 'block',
        overflow: 'visible',
    },
});

const ContentDiv = styled.div({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    minWidth: 0,
    '@media print': {
        display: 'block',
        overflow: 'visible',
    },
});

const MainArea = styled.div({
    flex: '1 0 auto',
    padding: '24px',
    '@media print': {
        padding: 0,
    },
});

const FooterDiv = styled.div({
    backgroundColor: 'lightgrey',
    width: '100%',
    flexShrink: 0,
    textAlign: 'center',
    '@media print': {
        display: 'none',
    },
});

const NavigationDiv = styled.div({
    '@media print': {
        display: 'none',
    },
});


function App() {
    const { organisationId } = useParams();
    const user = useSelector(state => state.auth.user);
    const organisation = user?.organisations?.find(org => org.organisationId === organisationId);
    const [mobileNavOpen, setMobileNavOpen] = useState(false);

    return (
        <AppDiv>
            <NavigationDiv>
                <Navigation
                    sidebarWidth={ SIDEBAR_WIDTH }
                    mobileOpen={ mobileNavOpen }
                    onMobileClose={ () => setMobileNavOpen(false) }
                />
            </NavigationDiv>
            <ContentDiv>
                { organisationId && organisation?.ready && (
                    <Box sx={{ minHeight: 61, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottom: '1px solid', borderColor: 'divider', backgroundColor: '#ffffff', position: 'relative', px: { xs: 1, md: 0 } }}>
                        <IconButton
                            onClick={ () => setMobileNavOpen(true) }
                            sx={{ position: 'absolute', left: 8, display: { xs: 'inline-flex', md: 'none' } }}
                            aria-label="Åbn menu"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Box sx={{ width: 300, maxWidth: { xs: 'calc(100% - 56px)', md: 300 } }}>
                            <OmniSearch />
                        </Box>
                    </Box>
                ) }
                <MainArea>
                    <Outlet />
                </MainArea>
                <FooterDiv>
                    <Footer />
                </FooterDiv>
            </ContentDiv>
        </AppDiv>
    );
}

export default App;
